import React, { useState, useEffect } from 'react';
import Selector from './Common/Selector/Selector';
import { getWorkTypesByAccountNumber } from '../services/workTypeService';

// Where two or more offered rows have the same raw Description, append each one's Wt so the user can
// tell them apart ("LABEL (22)"). A row with no Wt shows its key (Name) instead ("LABEL (900[01]-2)"),
// never "(null)". Unique labels are left exactly as they were.
// Only used when the caller opts in (Transcription Upload); display only -- never posted.
const presentText = (value) => (value === undefined || value === null || String(value).trim() === '') ? null : String(value);
export const workTypeLabeller = (rows) => {
    const counts = {};
    (rows || []).forEach(row => {
        const label = ((row && row.Description) || '').trim();
        counts[label] = (counts[label] || 0) + 1;
    });
    return (row) => {
        const label = ((row && row.Description) || '').trim();
        if (!(counts[label] > 1)) return row.Description;
        const suffix = presentText(row.Wt) || presentText(row.Name);
        return suffix === null ? row.Description : `${row.Description} (${suffix})`;
    };
};

// Picker-only key naming one exact row. Name ("900[01]-97") is not unique -- Prod 900 has two rows
// with that Name (TEST and MISC) -- so rows are keyed by WorkTypeId when every row has a distinct
// one, else by position in the list. Never posted.
export const ROW_KEY = "RowKey";
export const withRowKeys = (rows) => {
    const list = rows || [];
    const ids = list.map(row => (row && row.WorkTypeId !== undefined && row.WorkTypeId !== null && row.WorkTypeId !== '') ? String(row.WorkTypeId) : null);
    const byId = ids.every(id => id !== null) && new Set(ids).size === ids.length;
    return list.map((row, index) => ({ ...row, [ROW_KEY]: byId ? `id:${ids[index]}` : `ix:${index}` }));
};

const WorkTypeSelector = ({ account, onChange, keyProperty, selectedWorkType,additionalWorktypes, disambiguateLabels, keyByRow}) => {
    const [workTypes, setWorkTypes] = useState([]);
    //const [selectedWorkType, setSelectedWorkType] = useState(null);

    useEffect(() => {
        loadWorkTypes();
    },[])

    const loadWorkTypes = async () => {
        const { data } = await getWorkTypesByAccountNumber(account);
        if (data) {
            const loaded = additionalWorktypes ? [...additionalWorktypes,...data] : data;
            setWorkTypes(keyByRow ? withRowKeys(loaded) : loaded);
        }
    }

    const property = keyByRow ? ROW_KEY : (keyProperty || "Wt");

    const handleChange = (e) => {
        const { value } = e.target;
        //setSelectedWorkType(value);
        // Second argument: the selected row itself, so a caller keyed by row (Transcription) can
        // post that row's own Description and Name. Existing callers read only the first argument.
        onChange(value, workTypes.find(row => row && row[property] === value));
    }


    return (
        <Selector
            label="Work Type"
            required={ true }
            keyProperty={property}
            displayProperty={disambiguateLabels ? workTypeLabeller(workTypes) : "Description"}
            data={workTypes}
            value={selectedWorkType}
            onChange={handleChange}

        ></Selector>
    )
}
export default WorkTypeSelector;


// WEBPACK FOOTER //
// ./src/components/WorkTypeSelector.js